import { useState } from "react";

const KEY = "classe360-theme";

export function applyStoredTheme() {
  document.documentElement.classList.toggle("dark", localStorage.getItem(KEY) === "dark");
}

export function useThemeToggle() {
  const [dark, setDark] = useState(() => document.documentElement.classList.contains("dark"));
  const toggle = () => {
    const next = !dark;
    localStorage.setItem(KEY, next ? "dark" : "light");
    document.documentElement.classList.toggle("dark", next);
    setDark(next);
  };
  return { dark, toggle };
}
